import sizes from 'constants/sizes';
import { setModal } from 'modules/_shared/redux/modalActions';
import EditPartnerModal from 'modules/partners/modals/EditPartner';
import { store } from 'redux/store';
import { deletePartner } from 'modules/partners/utils/deletePartner';

function partnerOptions(i18n) {
  return [
    {
      icon: 'ni-eye',
      text: i18n.t('Watch'),
      url: '/detalle-socio',
    },
    {
      icon: 'ni-pen',
      text: i18n.t('Edit'),
      action: ({ data, societyId }) => {
        store.dispatch(
          setModal(
            <EditPartnerModal
              partner={data}
              societyId={societyId}
              size={sizes.XL}
            />
          )
        );
      },
      dontShowCurrent: ({ isReadOnlyUser, isReadOnly, isEditButtonDisabled }) =>
        isReadOnlyUser || isReadOnly || isEditButtonDisabled,
    },
    {
      icon: 'ni-repeat',
      text: i18n.t('Transactions'),
      url: '/detalle-socio',
      urlSuffix: '2',
    },
    {
      icon: 'ni-file',
      text: i18n.t('Documents'),
      url: '/detalle-socio',
      urlSuffix: '3',
    },
    {
      icon: 'ni-trash',
      text: i18n.t('Delete'),
      action: async ({ data, isAdmin, isReadOnly, isReadOnlyUser }) => {
        if (!isAdmin || isReadOnly || isReadOnlyUser) {
          return;
        }

        await deletePartner({ data });
      },
      dontShowCurrent: ({ isReadOnlyUser, isReadOnly, isAdmin }) =>
        !isAdmin || isReadOnlyUser || isReadOnly,
    },
  ];
}
export default partnerOptions;
